import React, { startTransition } from 'react';
import { 
  Box, 
  CssBaseline,
  Drawer, 
  AppBar, 
  Toolbar, 
  Typography, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  IconButton, 
  Avatar, 
  Divider,
  Button,
  Select,
  MenuItem,
  FormControl,
  Collapse,
  CircularProgress,
  Chip
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsIcon from '@mui/icons-material/Settings';
import RefreshIcon from '@mui/icons-material/Refresh';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PolicyIcon from '@mui/icons-material/Policy';
import FolderIcon from '@mui/icons-material/Folder';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WarningIcon from '@mui/icons-material/Warning';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import InventoryIcon from '@mui/icons-material/Inventory';
import RadarIcon from '@mui/icons-material/MyLocation';
import PublicIcon from '@mui/icons-material/Public';
import PeopleIcon from '@mui/icons-material/People';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { PrestadorAuthProvider, usePrestadorAuth } from './contexts/PrestadorAuthContext';
import TopBarActions from './components/layout/TopBarActions';
import { ChatProvider } from './contexts/ChatContext';
import ChatWidget from './components/chat/ChatWidget';
import IdentityCarousel from './components/IdentityCarousel';
import ErrorBoundary from './components/ErrorBoundary';
import API_CONFIG from './config/api';
import { getAuthenticatedUploadUrl } from './api/client';

// Importações diretas para evitar problemas de Suspense
import EntryPanelPage from './pages/entryPanel/EntryPanelPage';
import ModuloFiscalModule from './pages/moduloFiscal/ModuloFiscalModule';
import ArcaModule from './pages/arca/ArcaModule';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import GoogleLoginCallbackPage from './pages/GoogleLoginCallbackPage';
import EmailInboxPage from './pages/EmailInboxPage';
import ContratosPage from './pages/ContratosPage';
import ContratosDashboardPage from './pages/ContratosDashboardPage';
import ContratosSolicitacoesPage from './pages/ContratosSolicitacoesPage';
import ContratosProcessoContratacaoPage from './pages/ContratosProcessoContratacaoPage';
import ContratosAtividadesPage from './pages/ContratosAtividadesPage';
import ContratosAnaliseComparativaPage from './pages/ContratosAnaliseComparativaPage';
import NotasFiscaisPage from './pages/NotasFiscaisPage';
import DashboardFinanceiroPage from './pages/DashboardFinanceiroPage';
import PrestadoresPage from './pages/PrestadoresPage';
import FiscaisPage from './pages/FiscaisPage';
import AvaliacaoFornecedoresPage from './pages/AvaliacaoFornecedoresPage';
import RegulamentosPage from './pages/RegulamentosPage';
import RegulamentoAssinaturasNovoDocumentoPage from './pages/RegulamentoAssinaturasNovoDocumentoPage';
import RegulamentoAssinaturasDocumentosPage from './pages/RegulamentoAssinaturasDocumentosPage';
import RegulamentoAssinaturasDocumentoDetalhePage from './pages/RegulamentoAssinaturasDocumentoDetalhePage';
import ConfiguracaoPage from './pages/ConfiguracaoPage';
import PerfilPage from './pages/PerfilPage';
import PrestadorDashboardPage from './pages/PrestadorDashboardPage';
import PrestadorTopBarActions from './components/prestador/PrestadorTopBarActions';
import PrestadorContratoPage from './pages/PrestadorContratoPage';
import PortalPrestadorPropostaPage from './pages/prestador/PortalPrestadorPropostaPage';
import PrestacaoContasPage from './pages/PrestacaoContasPage';
import QualidadePage from './pages/QualidadePage';
import PlanejamentoPage from './pages/qualidade/PlanejamentoPage';
import PoliticasQualidadePage from './pages/qualidade/PoliticasQualidadePage';
import DocumentosPage from './pages/qualidade/DocumentosPage';
import AtividadesPage from './pages/qualidade/AtividadesPage';
import IndicadoresPage from './pages/qualidade/IndicadoresPage';
import OcorrenciasPage from './pages/qualidade/OcorrenciasPage';
import MetasPage from './pages/qualidade/MetasPage';
import RecursosPage from './pages/qualidade/RecursosPage';
import RadarPage from './pages/qualidade/RadarPage';
import PortalPage from './pages/qualidade/PortalPage';
import PainelIndicadoresPage from './pages/qualidade/PainelIndicadoresPage';
import MapaEstrategicoPage from './pages/qualidade/MapaEstrategicoPage';
import PlanoAcaoPage from './pages/qualidade/PlanoAcaoPage';
import AnaliseCriticaPage from './pages/qualidade/AnaliseCriticaPage';
import DesempenhoIndicadoresPage from './pages/qualidade/relatorios/DesempenhoIndicadoresPage';
import FichaTecnicaIndicadoresPage from './pages/qualidade/relatorios/FichaTecnicaIndicadoresPage';
import IndicadoresNaoAlimentadosPage from './pages/qualidade/relatorios/IndicadoresNaoAlimentadosPage';
import RadarAtividadesPage from './pages/qualidade/relatorios/RadarAtividadesPage';
import AlimentarIndicadoresPage from './pages/qualidade/funcionalidades/AlimentarIndicadoresPage';
import LgpdPage from './pages/lgpd/LgpdPage';
import LgpdConsentimentoDialog from './components/lgpd/LgpdConsentimentoDialog';
import GestaoUsuariosPage from './pages/GestaoUsuariosPage';
import SafetyHuddleModule from './pages/safety-huddle/SafetyHuddleModule';
import TrilhaAprendizadoModule from './pages/trilha-aprendizado/TrilhaAprendizadoModule';
import JuridicoModule from './pages/juridico/JuridicoModule';
import { apiFetch } from './api/client';
import { withUnidade } from './utils/storageByUnit';

// Componente de Loading removido - usando importações diretas

const drawerWidth = 240;

const contratosSubmenu = [
  { text: 'Dashboard', path: '/contratos/dashboard' },
  { text: 'Solicitações', path: '/contratos/solicitacoes' },
  { text: 'Processo de Contratação', path: '/contratos/processo-contratacao' },
  { text: 'Atividades', path: '/contratos/atividades' },
  { text: 'Análise Comparativa', path: '/contratos/analise-comparativa' },
];

const assinaturaSubmenu = [
  { text: '+ Novo Documento', path: '/assinaturas/novo' },
  { text: 'Todos os documentos', path: '/assinaturas/documentos' },
  { text: 'Atestos Mensais', path: '/assinaturas/atestos-mensais' },
  { text: 'Processo de Pagamento', path: '/assinaturas/processo-pagamento' },
  { text: 'Processo de Contratação', path: '/assinaturas/processo-contratacao' },
  { text: 'Aditivo', path: '/assinaturas/aditivo' },
  { text: 'Minuta', path: '/assinaturas/minuta' },
  { text: 'Documentos Diversos', path: '/assinaturas/diversos' },
];

const menuItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
  { 
    text: 'Contratos', 
    icon: <DescriptionIcon />, 
    path: '/contratos',
    hasSubmenu: true,
    submenu: contratosSubmenu
  },
  { text: 'Notas Fiscais', icon: <ReceiptIcon />, path: '/notas-fiscais' },
  { text: 'Prestação de Contas', icon: <AssessmentIcon />, path: '/prestacao-contas' },
  { text: 'Fiscais e Setores', icon: <BusinessIcon />, path: '/fiscais' },
  { text: 'Gestão de Equipe', icon: <PeopleIcon />, path: '/gestao-usuarios' },
  { text: 'Avaliação de Fornecedores', icon: <AssessmentIcon />, path: '/avaliacao-fornecedores' },
  { text: 'Regulamentos', icon: <DescriptionIcon />, path: '/regulamentos' },
  {
    text: 'Assinatura',
    icon: <BorderColorIcon />,
    path: '/assinaturas',
    hasSubmenu: true,
    submenu: assinaturaSubmenu
  },
];

// Submenu de Planejamento
const planejamentoSubmenu = [
  { text: 'Painel de Indicadores', path: '/qualidade/planejamento/painel-indicadores' },
  { text: 'Mapa Estratégico', path: '/qualidade/planejamento/mapa-estrategico' },
  { text: 'Plano de Ação (5w2h)', path: '/qualidade/planejamento/plano-acao' },
  { text: 'Reuniões de Análise Crítica', path: '/qualidade/planejamento/reunioes-analise' },
  { 
    text: 'Relatórios', 
    hasSubmenu: true,
    submenu: [
      { text: 'Desempenho dos Indicadores', path: '/qualidade/planejamento/relatorios/desempenho-indicadores' },
      { text: 'Ficha Técnica de Indicadores', path: '/qualidade/planejamento/relatorios/ficha-tecnica-indicadores' },
      { text: 'Indicadores Não Alimentados', path: '/qualidade/planejamento/relatorios/indicadores-nao-alimentados' },
      { text: 'Radar de Atividades', path: '/qualidade/planejamento/relatorios/radar-atividades' }
    ]
  },
  { 
    text: 'Funcionalidades', 
    hasSubmenu: true,
    submenu: [
      { text: 'Alimentar Indicadores', path: '/qualidade/planejamento/funcionalidades/alimentar-indicadores' }
    ]
  },
  { text: 'Painel Gestão à Vista', path: '/qualidade/planejamento/gestao-vista' },
  { text: 'Configurar Dashboard', path: '/qualidade/planejamento/configurar-dashboard' },
];

const menuItemsQualidade = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/qualidade' },
  { 
    text: 'Planejamento', 
    icon: <CalendarTodayIcon />, 
    path: '/qualidade/planejamento',
    hasSubmenu: true,
    submenu: planejamentoSubmenu
  },
  { text: 'Políticas de Qualidade', icon: <PolicyIcon />, path: '/qualidade/politicas' },
  { text: 'Gestão de Documentos', icon: <FolderIcon />, path: '/qualidade/documentos' },
  { text: 'Atividades', icon: <AssignmentIcon />, path: '/qualidade/atividades' },
  { text: 'Indicadores', icon: <TrendingUpIcon />, path: '/qualidade/indicadores' },
  { text: 'Ocorrências', icon: <WarningIcon />, path: '/qualidade/ocorrencias' },
  { text: 'Metas (Gols)', icon: <EmojiEventsIcon />, path: '/qualidade/metas' },
  { text: 'Recursos', icon: <InventoryIcon />, path: '/qualidade/recursos' },
  { text: 'Radar', icon: <RadarIcon />, path: '/qualidade/radar' },
  { text: 'Portal', icon: <PublicIcon />, path: '/qualidade/portal' },
];

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    user,
    sessionLoading,
    logout,
    isFiscal,
    fiscalSetor,
    fotoPerfil,
    unidades,
    unidadeSelecionada,
    setUnidadeSelecionada,
    rbacRole,
    isGlobalUser,
    hasPermission,
    substituindoLabel,
  } = useAuth();
  const { prestador, logoutPrestador } = usePrestadorAuth();

  const fotoPerfilUrl = fotoPerfil ? getAuthenticatedUploadUrl(fotoPerfil) : '';
  const globalUser = isGlobalUser();

  const cargoChipColor = (() => {
    if (rbacRole === 'LOCAL_APPROVER' || rbacRole === 'GLOBAL_VIEWER' || rbacRole === 'SUPER_ADMIN') return 'warning';
    if (
      rbacRole === 'LOCAL_ADMIN' ||
      rbacRole === 'LOCAL_OPERATOR' ||
      rbacRole === 'FINANCEIRO' ||
      rbacRole === 'FISCAL_MONITOR' ||
      rbacRole === 'FINANCEIRO_ANALISTA'
    ) {
      return 'primary';
    }
    if (rbacRole === 'FISCAL' || rbacRole === 'SECTOR_VIEWER') return 'default';
    return 'default';
  })();

  const formatCargoLabel = (s) =>
    s && typeof s === 'string' ? s.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()) : s;

  const cargoChipLabel = formatCargoLabel(
    user?.cargo ||
      (isFiscal ? fiscalSetor : null) ||
      (rbacRole ? rbacRole.replace(/_/g, ' ') : null) ||
      user?.tipo ||
      'Usuário'
  );

  // Debug: identidade / RBAC
  React.useEffect(() => {
    console.log('🖼️ Foto de perfil no App.js:', fotoPerfil);
    console.log('👤 Usuário:', user);
    console.log('🔐 rbacRole:', rbacRole);
  }, [fotoPerfil, user, rbacRole]);

  // Verificar se está no sistema de Qualidade
  const isQualidadeSystem = location.pathname.startsWith('/qualidade');
  
  // Estado para controlar expansão do menu Planejamento
  const [planejamentoExpanded, setPlanejamentoExpanded] = React.useState(
    location.pathname.startsWith('/qualidade/planejamento')
  );
  const [contratosExpanded, setContratosExpanded] = React.useState(
    location.pathname.startsWith('/contratos')
  );
  const [relatoriosExpanded, setRelatoriosExpanded] = React.useState(
    location.pathname.startsWith('/qualidade/planejamento/relatorios')
  );
  const [funcionalidadesExpanded, setFuncionalidadesExpanded] = React.useState(
    location.pathname.startsWith('/qualidade/planejamento/funcionalidades')
  );
  // Menu lateral: recolhido/expandido apenas pelos botões (sem colapso automático)
  const [drawerCollapsed, setDrawerCollapsed] = React.useState(true);
  const [lgpdPendentes, setLgpdPendentes] = React.useState([]);
  const [lgpdConsentOpen, setLgpdConsentOpen] = React.useState(false);

  const verificarConsentimentoLgpd = React.useCallback(async () => {
    if (!user || sessionLoading) return;
    try {
      const res = await apiFetch(withUnidade('/api/lgpd/consentimentos/pendentes', unidadeSelecionada));
      if (res.ok) {
        const pendentes = await res.json();
        setLgpdPendentes(Array.isArray(pendentes) ? pendentes : []);
        setLgpdConsentOpen(Array.isArray(pendentes) && pendentes.length > 0);
      }
    } catch {
      setLgpdPendentes([]);
    }
  }, [user, sessionLoading, unidadeSelecionada?.codigo]);

  React.useEffect(() => {
    verificarConsentimentoLgpd();
  }, [verificarConsentimentoLgpd]);

  const expandDrawer = () => setDrawerCollapsed(false);
  const collapseDrawer = () => setDrawerCollapsed(true);

  // Atualizar expansão quando a rota mudar
  React.useEffect(() => {
    if (location.pathname.startsWith('/contratos')) {
      setContratosExpanded(true);
    }
    if (location.pathname.startsWith('/qualidade/planejamento')) {
      setPlanejamentoExpanded(true);
    }
    if (location.pathname.startsWith('/qualidade/planejamento/relatorios')) {
      setRelatoriosExpanded(true);
    }
    if (location.pathname.startsWith('/qualidade/planejamento/funcionalidades')) {
      setFuncionalidadesExpanded(true);
    }
  }, [location.pathname]);

  // Função para obter o título baseado na rota atual
  const getPageTitle = (path) => {
    switch (path) {
      case '/qualidade/planejamento':
        return 'Planejamento';
      case '/qualidade/planejamento/painel-indicadores':
        return 'Painel de Indicadores';
      case '/qualidade/planejamento/mapa-estrategico':
        return 'Mapa Estratégico';
      case '/qualidade/planejamento/plano-acao':
        return 'Plano de Ação (5w2h)';
      case '/qualidade/planejamento/reunioes-analise':
        return 'Reuniões de Análise Crítica';
      case '/qualidade/planejamento/relatorios/desempenho-indicadores':
        return 'Desempenho dos Indicadores';
      case '/qualidade/planejamento/relatorios/ficha-tecnica-indicadores':
        return 'Ficha Técnica de Indicadores';
      case '/qualidade/planejamento/relatorios/indicadores-nao-alimentados':
        return 'Indicadores Não Alimentados';
      case '/qualidade/planejamento/relatorios/radar-atividades':
        return 'Radar de Atividades';
      case '/qualidade/planejamento/funcionalidades/alimentar-indicadores':
        return 'Alimentar Indicadores';
      case '/qualidade/planejamento/gestao-vista':
        return 'Painel Gestão à Vista';
      case '/qualidade/planejamento/configurar-dashboard':
        return 'Configurar Dashboard';
      case '/qualidade/politicas':
        return 'Políticas de Qualidade';
      case '/qualidade/documentos':
        return 'Gestão de Documentos';
      case '/qualidade/atividades':
        return 'Atividades';
      case '/qualidade/indicadores':
        return 'Indicadores';
      case '/qualidade/ocorrencias':
        return 'Ocorrências';
      case '/qualidade/metas':
        return 'Metas (Gols)';
      case '/qualidade/recursos':
        return 'Recursos';
      case '/qualidade/radar':
        return 'Radar';
      case '/qualidade/portal':
        return 'Portal';
      case '/assinaturas/novo':
        return 'Novo Documento - Assinatura';
      case '/assinaturas/documentos':
        return 'Documentos para Assinatura';
      case '/assinaturas/atestos-mensais':
        return 'Atestos Mensais';
      case '/assinaturas/processo-pagamento':
        return 'Assinaturas — Processo de Pagamento';
      case '/assinaturas/processo-contratacao':
        return 'Assinaturas — Processo de Contratação';
      case '/assinaturas/aditivo':
        return 'Assinaturas — Aditivo';
      case '/assinaturas/minuta':
        return 'Assinaturas — Minuta';
      case '/assinaturas/diversos':
        return 'Assinaturas — Documentos Diversos';
      case '/prestador/dashboard':
        return 'Painel do Prestador';
      case '/contratos/solicitacoes':
        return 'Solicitações de Contratos';
      case '/contratos/processo-contratacao':
        return 'Processo de Contratação';
      case '/contratos/dashboard':
        return 'Dashboard de Contratos';
      case '/contratos/atividades':
        return 'Atividades de Contratos';
      case '/contratos/analise-comparativa':
        return 'Análise Comparativa';
      case '/configuracao':
        return 'Configuração';
      case '/perfil':
        return 'Perfil';
      case '/gestao-usuarios':
        return 'Gestão de Equipe e Acessos';
      case '/prestacao-contas':
        return 'Prestação de Contas';
      case '/notas-fiscais':
        return 'Notas Fiscais';
      case '/notas-fiscais/processo-pagamento':
        return 'Atividades de Notas Fiscais';
      case '/arca':
        return 'ARCA';
      case '/safety-huddle':
        return 'Safety Huddle';
      default:
        if (path.startsWith('/assinaturas/documentos/')) {
          return 'Detalhes do Documento';
        }
        if (path.startsWith('/safety-huddle')) {
          return 'Safety Huddle';
        }
        if (path.startsWith('/modulos/fiscal/')) {
          return 'Módulo do Fiscal';
        }
        return 'Dashboard';
    }
  };

  // Menu filtrado pelo RBAC (hasPermission) — UI only; backend deve revalidar
  const getMenuItems = () => {
    if (isQualidadeSystem) return menuItemsQualidade;
    return menuItems.filter((item) => {
      if (item.text === 'Assinatura') return hasPermission('Assinaturas');
      if (item.text === 'Contratos') return hasPermission('Contratos');
      if (item.text === 'Notas Fiscais') return hasPermission('NotasFiscais');
      if (item.text === 'Gestão de Equipe') return hasPermission('GestaoUsuarios');
      return true;
    });
  };

  const menuPermissionKey = (text) => {
    const map = {
      Assinatura: 'Assinaturas',
      Contratos: 'Contratos',
      'Notas Fiscais': 'NotasFiscais',
      Prestadores: 'Prestadores',
      Configuração: 'Configuracao',
      'Gestão de Equipe': 'GestaoUsuarios'
    };
    return map[text] || text;
  };

  // Portal público — após todos os hooks (rules-of-hooks); sem login/cadastro
  if (location.pathname.startsWith('/portal-prestador/propostas/')) {
    return (
      <Routes>
        <Route path="/portal-prestador/propostas/:token" element={<PortalPrestadorPropostaPage />} />
      </Routes>
    );
  }

  // Prestador externo OU God Mode (admin ISG em rota /prestador/*)
  if (prestador && (!user || location.pathname.startsWith('/prestador'))) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: '#f5f9ff' }}>
        <AppBar position="static" elevation={0} sx={{ background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)', color: '#fff', mb: 0 }}>
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>
              Portal do Prestador — SGC
              {prestador.godMode ? ' (God Mode)' : ''}
            </Typography>
            <PrestadorTopBarActions />
            <Button
              color="inherit"
              onClick={() => {
                logoutPrestador();
                navigate(user ? '/configuracao' : '/login');
              }}
              sx={{ textTransform: 'none', ml: 1 }}
            >
              {user ? 'Voltar ao SGC' : 'Sair'}
            </Button>
          </Toolbar>
        </AppBar>
        <Routes>
          <Route path="/prestador/dashboard" element={<PrestadorDashboardPage />} />
          <Route path="/prestador/contratos/:numeroContrato" element={<PrestadorContratoPage />} />
          <Route path="*" element={<Navigate to="/prestador/dashboard" replace />} />
        </Routes>
      </Box>
    );
  }

  // Aguardar restauração da sessão antes de exibir login ou app (evita flash e erros de DOM)
  if (sessionLoading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f9ff' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Se não estiver logado (ISG nem prestador), mostrar tela de login
  if (!user) {
    if (location.pathname.startsWith('/login/google-callback')) {
      return <GoogleLoginCallbackPage />;
    }
    return <LoginPage />;
  }

  const isHomePanel = location.pathname === '/home';
  const isArcaModule = location.pathname.startsWith('/arca');
  const isSafetyHuddleModule = location.pathname.startsWith('/safety-huddle');
  const isTrilhaModule = location.pathname.startsWith('/trilha-aprendizado');
  const isJuridicoModule = location.pathname.startsWith('/juridico');
  const isModuloFiscal = location.pathname.startsWith('/modulos/fiscal');

  return (
    <ChatProvider user={user} fotoPerfil={fotoPerfil} unidadeSelecionada={unidadeSelecionada}>
      {isHomePanel ? (
        <EntryPanelPage />
      ) : isArcaModule ? (
        <ArcaModule />
      ) : isSafetyHuddleModule ? (
        <SafetyHuddleModule />
      ) : isTrilhaModule ? (
        <TrilhaAprendizadoModule />
      ) : isJuridicoModule ? (
        <JuridicoModule />
      ) : isModuloFiscal ? (
        <ModuloFiscalModule />
      ) : (
    <Box sx={{ 
      display: 'flex', 
      minHeight: '100vh',
      width: '100%',
      maxWidth: '100vw',
      overflow: 'hidden',
      boxSizing: 'border-box',
      background: `linear-gradient(135deg, #f8fafc 0%, #e3f2fd 50%, #f8fafc 100%)`,
      position: 'relative',
      '&::before': {
        content: '"ISG"',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '200px',
        fontWeight: 'bold',
        color: 'rgba(255, 255, 255, 0.03)',
        pointerEvents: 'none',
        userSelect: 'none',
        zIndex: 0
      }
    }}>
      <CssBaseline />
      {/* Botão para expandir quando recolhido */}
      {drawerCollapsed && (
        <IconButton
          onClick={expandDrawer}
          sx={{
            position: 'fixed',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1301,
            bgcolor: 'background.paper',
            boxShadow: 2,
            borderRadius: '0 8px 8px 0',
            '&:hover': { bgcolor: 'primary.main', color: 'white' },
          }}
        >
          <ChevronRightIcon />
        </IconButton>
      )}

      {/* Drawer lateral futurista */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerCollapsed ? 0 : drawerWidth,
          flexShrink: 0,
          transition: 'width 0.3s ease',
          [`& .MuiDrawer-paper`]: { 
            width: drawerWidth, 
            boxSizing: 'border-box', 
            background: 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(240,248,255,0.9) 100%)',
            backdropFilter: 'blur(10px)',
            borderRight: '1px solid rgba(255,255,255,0.2)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
            borderRadius: '0 20px 20px 0',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            overflow: 'hidden',
            transition: 'margin 0.3s ease, width 0.3s ease',
            marginLeft: drawerCollapsed ? -drawerWidth : 0,
          },
        }}
      >
        {/* Botão recolher - canto superior direito do drawer */}
        <IconButton
          onClick={collapseDrawer}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 10,
            bgcolor: 'rgba(255,255,255,0.9)',
            '&:hover': { bgcolor: 'rgba(255,255,255,1)' },
          }}
        >
          <ChevronLeftIcon />
        </IconButton>

        {/* Topo: Botão de perfil centralizado e maior */}
        <Box sx={{
          minHeight: { xs: 70, sm: 80, md: 100 },
          height: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 40%, #7b1fa2 100%)',
          borderRadius: '0 20px 0 0',
          mb: 0,
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 8px 32px 0 rgba(123,31,162,0.10), 0 1.5px 8px 0 rgba(25,118,210,0.10)',
        }}>
          {/* Efeito de brilho sutil */}
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'radial-gradient(circle at 60% 30%, rgba(255,255,255,0.12) 0%, transparent 70%)',
            zIndex: 1,
            pointerEvents: 'none',
          }} />
          <IconButton color="inherit" onClick={() => navigate('/perfil')} sx={{ p: 0, zIndex: 2 }}>
            <Avatar 
              src={fotoPerfilUrl}
              onError={(e) => {
                console.error('❌ Erro ao carregar foto:', fotoPerfilUrl);
                e.target.style.display = 'none';
              }}
              sx={{
                width: { xs: 48, sm: 56, md: 64 },
                height: { xs: 48, sm: 56, md: 64 },
                bgcolor: 'primary.main',
                fontSize: { xs: 20, sm: 28, md: 32 },
                boxShadow: '0 4px 24px 0 rgba(25,118,210,0.25), 0 1.5px 8px 0 rgba(123,31,162,0.10)',
                border: '4px solid #fff',
                transition: 'box-shadow 0.3s',
                objectFit: 'cover',
                objectPosition: 'center top',
                '&:hover': {
                  boxShadow: '0 8px 32px 0 rgba(123,31,162,0.18), 0 2px 12px 0 rgba(25,118,210,0.18)'
                }
              }}
            >
              {!fotoPerfil && (user?.nome || user)?.charAt(0)?.toUpperCase()}
            </Avatar>
          </IconButton>
        </Box>
        
        {/* Unidade: seletor só para isGlobalUser(); demais veem o nome fixo */}
        <Box sx={{ px: 2, py: 1 }}>
          {globalUser ? (
            <FormControl fullWidth size="small" sx={{
              background: 'white',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              <Select
                value={unidadeSelecionada?.codigo || ''}
                onChange={(e) => {
                  const unidade = unidades.find(u => u.codigo === e.target.value);
                  if (unidade) setUnidadeSelecionada(unidade);
                }}
                displayEmpty
                sx={{
                  fontWeight: 600,
                  color: 'primary.main',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                    borderWidth: 2
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.dark'
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.dark'
                  }
                }}
              >
                {unidades.map((unidade) => (
                  <MenuItem key={unidade.id} value={unidade.codigo}>
                    <Typography variant="body2" fontWeight={600}>
                      {unidade.nome}
                    </Typography>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Typography
              variant="body2"
              fontWeight={700}
              color="primary.main"
              sx={{
                textAlign: 'center',
                px: 1,
                py: 1,
                borderRadius: 2,
                bgcolor: 'rgba(25,118,210,0.08)',
                border: '1px solid rgba(25,118,210,0.2)'
              }}
            >
              {unidadeSelecionada?.nome || 'Unidade'}
            </Typography>
          )}
        </Box>
        
        {/* Menu colado, sem Divider */}
        <List sx={{ px: 2, mt: 0, pt: 0, mb: 0 }}>
          {getMenuItems().map((item) => {
            if (menuPermissionKey(item.text) && !hasPermission(menuPermissionKey(item.text)) && ['Assinatura', 'Contratos', 'Notas Fiscais', 'Gestão de Equipe'].includes(item.text)) {
              return null;
            }
            // Se tiver submenu (Planejamento)
            if (item.hasSubmenu && item.submenu) {
              const isSubmenuActive = item.submenu.some(subItem => location.pathname === subItem.path || location.pathname.startsWith(subItem.path + '/'));
              
              let isExpanded = isSubmenuActive;
              let toggleExpanded = null;

              if (item.text === 'Planejamento') {
                isExpanded = planejamentoExpanded || isSubmenuActive;
                toggleExpanded = () => setPlanejamentoExpanded(prev => !prev);
              } else if (item.text === 'Contratos') {
                isExpanded = contratosExpanded || isSubmenuActive;
                toggleExpanded = () => setContratosExpanded(prev => !prev);
              }
              
              return (
                <React.Fragment key={item.text}>
                  <ListItem 
                    button 
                    onClick={() => {
                      if (item.path) {
                        startTransition(() => navigate(item.path));
                      }
                      if (toggleExpanded) {
                        toggleExpanded();
                      }
                    }}
                    selected={isSubmenuActive || location.pathname === item.path}
                    sx={{
                      borderRadius: 3,
                      mb: 1,
                      transition: 'all 0.3s ease',
                      backgroundColor: isSubmenuActive 
                        ? 'rgba(25,118,210,0.1)' 
                        : 'transparent',
                      '&:hover': {
                        background: 'linear-gradient(135deg, rgba(25,118,210,0.1) 0%, rgba(66,165,245,0.1) 100%)',
                        transform: 'translateX(5px)',
                        boxShadow: '0 4px 12px rgba(25,118,210,0.2)'
                      }
                    }}
                  >
                    <ListItemIcon sx={{ color: 'primary.main' }}>{item.icon}</ListItemIcon>
                    <ListItemText 
                      primary={item.text} 
                      primaryTypographyProps={{ 
                        fontWeight: isSubmenuActive ? 700 : 500,
                        fontSize: '0.9rem'
                      }}
                    />
                    {isExpanded ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.submenu.map((subItem) => {
                        // Se o subitem tem submenu próprio (Relatórios, Funcionalidades)
                        if (subItem.hasSubmenu && subItem.submenu) {
                          const isSubmenuActive = subItem.submenu.some(subSubItem => location.pathname === subSubItem.path);
                          const isExpanded = (subItem.text === 'Relatórios' && relatoriosExpanded) ||
                                           (subItem.text === 'Funcionalidades' && funcionalidadesExpanded) ||
                                           isSubmenuActive;
                          
                          return (
                            <React.Fragment key={subItem.text}>
                              <ListItem
                                button
                                onClick={() => {
                                  if (subItem.text === 'Relatórios') {
                                    setRelatoriosExpanded(!relatoriosExpanded);
                                  } else if (subItem.text === 'Funcionalidades') {
                                    setFuncionalidadesExpanded(!funcionalidadesExpanded);
                                  }
                                }}
                                selected={isSubmenuActive}
                                sx={{
                                  pl: 4,
                                  borderRadius: 2,
                                  mb: 0.5,
                                  ml: 2,
                                  mr: 2,
                                  transition: 'all 0.3s ease',
                                  backgroundColor: isSubmenuActive 
                                    ? 'rgba(25,118,210,0.15)' 
                                    : 'transparent',
                                  '&:hover': {
                                    background: 'rgba(25,118,210,0.08)',
                                    transform: 'translateX(3px)'
                                  }
                                }}
                              >
                                <ListItemText 
                                  primary={subItem.text}
                                  primaryTypographyProps={{
                                    fontSize: '0.85rem',
                                    fontWeight: isSubmenuActive ? 600 : 400
                                  }}
                                />
                                {isExpanded ? <ExpandLess sx={{ fontSize: '1rem' }} /> : <ExpandMore sx={{ fontSize: '1rem' }} />}
                              </ListItem>
                              <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                  {subItem.submenu.map((subSubItem) => (
                                    <ListItem
                                      button
                                      key={subSubItem.text}
                                      onClick={() => startTransition(() => navigate(subSubItem.path))}
                                      selected={location.pathname === subSubItem.path}
                                      sx={{
                                        pl: 6,
                                        borderRadius: 2,
                                        mb: 0.5,
                                        ml: 3,
                                        mr: 2,
                                        transition: 'all 0.3s ease',
                                        backgroundColor: location.pathname === subSubItem.path 
                                          ? 'rgba(25,118,210,0.15)' 
                                          : 'transparent',
                                        '&:hover': {
                                          background: 'rgba(25,118,210,0.08)',
                                          transform: 'translateX(3px)'
                                        }
                                      }}
                                    >
                                      <ListItemText 
                                        primary={subSubItem.text}
                                        primaryTypographyProps={{
                                          fontSize: '0.8rem',
                                          fontWeight: location.pathname === subSubItem.path ? 600 : 400
                                        }}
                                      />
                                    </ListItem>
                                  ))}
                                </List>
                              </Collapse>
                            </React.Fragment>
                          );
                        }
                        
                        // Subitem normal (sem submenu)
                        return (
                          <ListItem
                            button
                            key={subItem.text}
                            onClick={() => startTransition(() => navigate(subItem.path))}
                            selected={location.pathname === subItem.path}
                            sx={{
                              pl: 4,
                              borderRadius: 2,
                              mb: 0.5,
                              ml: 2,
                              mr: 2,
                              transition: 'all 0.3s ease',
                              backgroundColor: location.pathname === subItem.path 
                                ? 'rgba(25,118,210,0.15)' 
                                : 'transparent',
                              '&:hover': {
                                background: 'rgba(25,118,210,0.08)',
                                transform: 'translateX(3px)'
                              }
                            }}
                          >
                            <ListItemText 
                              primary={subItem.text}
                              primaryTypographyProps={{
                                fontSize: '0.85rem',
                                fontWeight: location.pathname === subItem.path ? 600 : 400
                              }}
                            />
                          </ListItem>
                        );
                      })}
                    </List>
                  </Collapse>
                </React.Fragment>
              );
            }
            
            // Item normal sem submenu
            return (
            <ListItem 
              button 
              key={item.text} 
              onClick={() => startTransition(() => navigate(item.path))}
                selected={location.pathname === item.path}
              sx={{
                borderRadius: 3,
                mb: 1,
                transition: 'all 0.3s ease',
                  backgroundColor: location.pathname === item.path 
                    ? 'rgba(25,118,210,0.1)' 
                    : 'transparent',
                '&:hover': {
                  background: 'linear-gradient(135deg, rgba(25,118,210,0.1) 0%, rgba(66,165,245,0.1) 100%)',
                  transform: 'translateX(5px)',
                  boxShadow: '0 4px 12px rgba(25,118,210,0.2)'
                }
              }}
            >
              <ListItemIcon sx={{ color: 'primary.main' }}>{item.icon}</ListItemIcon>
              <ListItemText 
                primary={item.text} 
                primaryTypographyProps={{ 
                    fontWeight: location.pathname === item.path ? 700 : 500,
                  fontSize: '0.9rem'
                }}
              />
            </ListItem>
            );
          })}
          {!isQualidadeSystem && user && (
            <ListItem button onClick={() => startTransition(() => navigate('/lgpd'))} selected={location.pathname === '/lgpd'}>
              <ListItemIcon><PolicyIcon /></ListItemIcon>
              <ListItemText primary="LGPD / Privacidade" />
            </ListItem>
          )}
          {hasPermission('Prestadores') && !isQualidadeSystem && (
            <>
              <Divider sx={{ my: 1 }} />
              <ListItem button onClick={() => startTransition(() => navigate('/prestadores'))}>
                <ListItemIcon><BusinessIcon /></ListItemIcon>
                <ListItemText primary="Prestadores" />
              </ListItem>
            </>
          )}
          {hasPermission('Configuracao') && !isQualidadeSystem && (
            <ListItem button onClick={() => startTransition(() => navigate('/configuracao'))}>
              <ListItemIcon><SettingsIcon /></ListItemIcon>
              <ListItemText primary="Configuração" />
            </ListItem>
          )}
        </List>
        {/* Rodapé: Bloco de usuário centralizado com botão sair */}
        <Box sx={{
          width: '100%',
          py: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          borderTop: '1px solid #e3e3e3',
          background: 'transparent',
        }}>
          <Avatar 
            src={fotoPerfilUrl}
            onError={(e) => {
              console.error('❌ Erro ao carregar foto no sidebar inferior:', fotoPerfilUrl);
              e.target.style.display = 'none';
            }}
            sx={{ width: 40, height: 40, mb: 1, bgcolor: 'primary.main', fontSize: 20 }}
          >
            {!fotoPerfil && (user?.nome || user)?.charAt(0)?.toUpperCase()}
          </Avatar>
          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5, textAlign: 'center', maxWidth: 180, wordBreak: 'break-all' }}>{user?.nome || user}</Typography>
          <Chip
            label={cargoChipLabel}
            size="small"
            color={cargoChipColor}
            sx={{ mb: 1, fontWeight: 600, maxWidth: 180 }}
          />
          <Button variant="outlined" color="error" size="small" onClick={() => { logout(); startTransition(() => navigate('/login')); }}>
            Sair
          </Button>
        </Box>
      </Drawer>
      {/* Conteúdo principal - minWidth: 0 evita overflow horizontal em flex */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          width: '100%',
          maxWidth: '100%',
          overflowX: 'hidden',
          overflowY: 'auto',
          p: { xs: 1.5, sm: 2, md: 3 },
          position: 'relative',
          zIndex: 1,
          boxSizing: 'border-box',
        }}
      >
        <AppBar position="static" elevation={0} sx={{ 
          background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(240,248,255,0.9) 100%)',
          backdropFilter: 'blur(10px)',
          color: '#1976d2', 
          mb: 3, 
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          borderBottom: '1px solid rgba(255,255,255,0.3)',
          borderRadius: '0 0 20px 20px'
        }}>
          <Toolbar sx={{ flexWrap: 'wrap', minHeight: 0, px: { xs: 1, sm: 2 } }}>
            {/* Botão Voltar - aparece quando não estiver na home */}
            {location.pathname !== '/home' && (
              <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/home')}
                size="small"
                sx={{ 
                  mr: 2,
                  color: 'primary.main',
                  fontWeight: 600,
                  flexShrink: 0,
                  '&:hover': {
                    background: 'rgba(25, 118, 210, 0.1)'
                  }
                }}
              >
                Voltar ao Painel
              </Button>
            )}
            <Typography variant="h5" fontWeight={700} sx={{ flexGrow: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {getPageTitle(location.pathname)}
            </Typography>
            {substituindoLabel && (
              <Chip
                size="small"
                color="secondary"
                variant="outlined"
                label={substituindoLabel}
                sx={{ mr: 1, maxWidth: 280, bgcolor: 'rgba(255,255,255,0.15)', color: 'inherit', borderColor: 'rgba(255,255,255,0.4)' }}
              />
            )}
            <TopBarActions />
            <IconButton
              onClick={() => {
                // Disparar evento customizado baseado na página atual
                const eventName = location.pathname === '/' ? 'refreshDashboard' : 'refreshPage';
                window.dispatchEvent(new CustomEvent(eventName));
              }}
              sx={{ 
                background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
                color: 'white', 
                boxShadow: '0 4px 12px rgba(25,118,210,0.3)',
                transition: 'all 0.3s ease',
                '&:hover': { 
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 20px rgba(25,118,210,0.4)'
                }
              }}
            >
              <RefreshIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        
        {/* Carrossel da Identidade Organizacional - Header Global */}
        <IdentityCarousel />
        
        <ErrorBoundary>
          <Box sx={{ minWidth: 0, maxWidth: '100%', overflowX: 'hidden' }}>
          <Routes>
            <Route path="/home" element={<EntryPanelPage />} />
            {/* Rotas do Sistema de Qualidade */}
            <Route path="/qualidade" element={<QualidadePage />} />
            <Route path="/qualidade/planejamento" element={<PlanejamentoPage />} />
            <Route path="/qualidade/planejamento/painel-indicadores" element={<PainelIndicadoresPage />} />
            <Route path="/qualidade/planejamento/mapa-estrategico" element={<MapaEstrategicoPage />} />
            <Route path="/qualidade/planejamento/plano-acao" element={<PlanoAcaoPage />} />
            <Route path="/qualidade/planejamento/reunioes-analise" element={<AnaliseCriticaPage />} />
            <Route path="/qualidade/planejamento/relatorios/desempenho-indicadores" element={<DesempenhoIndicadoresPage />} />
            <Route path="/qualidade/planejamento/relatorios/ficha-tecnica-indicadores" element={<FichaTecnicaIndicadoresPage />} />
            <Route path="/qualidade/planejamento/relatorios/indicadores-nao-alimentados" element={<IndicadoresNaoAlimentadosPage />} />
            <Route path="/qualidade/planejamento/relatorios/radar-atividades" element={<RadarAtividadesPage />} />
            <Route path="/qualidade/planejamento/funcionalidades/alimentar-indicadores" element={<AlimentarIndicadoresPage />} />
            <Route path="/qualidade/planejamento/gestao-vista" element={<PlanejamentoPage />} />
            <Route path="/qualidade/planejamento/configurar-dashboard" element={<PlanejamentoPage />} />
            <Route path="/qualidade/politicas" element={<PoliticasQualidadePage />} />
            <Route path="/qualidade/documentos" element={<DocumentosPage />} />
            <Route path="/qualidade/atividades" element={<AtividadesPage />} />
            <Route path="/qualidade/indicadores" element={<IndicadoresPage />} />
            <Route path="/qualidade/ocorrencias" element={<OcorrenciasPage />} />
            <Route path="/qualidade/metas" element={<MetasPage />} />
            <Route path="/qualidade/recursos" element={<RecursosPage />} />
            <Route path="/qualidade/radar" element={<RadarPage />} />
            <Route path="/qualidade/portal" element={<PortalPage />} />
            <Route path="/portal-prestador/propostas/:token" element={<PortalPrestadorPropostaPage />} />
            {/* Rotas do Sistema de Contratos */}
            <Route path="/" element={<DashboardPage />} />
            <Route path="/login" element={
              user ? <Navigate to="/home" replace /> : <LoginPage />
            } />
            <Route path="/login/google-callback" element={<GoogleLoginCallbackPage />} />
            <Route path="/email" element={<EmailInboxPage />} />
            <Route path="/contratos" element={<ContratosPage />} />
            <Route path="/contratos/dashboard" element={<ContratosDashboardPage />} />
            <Route path="/contratos/solicitacoes" element={<ContratosSolicitacoesPage />} />
            <Route path="/contratos/processo-contratacao" element={<ContratosProcessoContratacaoPage />} />
            <Route path="/contratos/atividades" element={<ContratosAtividadesPage />} />
            <Route path="/contratos/analise-comparativa" element={<ContratosAnaliseComparativaPage />} />
            <Route path="/notas-fiscais" element={<NotasFiscaisPage />} />
            <Route path="/notas-fiscais/processo-pagamento" element={<Navigate to="/notas-fiscais" state={{ menu: 'atividades-notas-fiscais' }} replace />} />
            <Route path="/prestacao-contas" element={<PrestacaoContasPage />} />
            <Route path="/dashboard-financeiro" element={<DashboardFinanceiroPage />} />
            <Route path="/prestadores" element={hasPermission('Prestadores') ? <PrestadoresPage /> : <Navigate to="/home" replace />} />
            <Route path="/fiscais" element={<FiscaisPage />} />
            <Route path="/avaliacao-fornecedores" element={<AvaliacaoFornecedoresPage />} />
            <Route path="/regulamentos" element={<RegulamentosPage />} />
            {/* Assinatura digital: RBAC hasPermission('Assinaturas') */}
            <Route path="/assinaturas" element={hasPermission('Assinaturas') ? <Navigate to="/assinaturas/documentos" replace /> : <Navigate to="/home" replace />} />
            <Route path="/assinaturas/novo" element={hasPermission('Assinaturas') ? <RegulamentoAssinaturasNovoDocumentoPage /> : <Navigate to="/home" replace />} />
            <Route path="/assinaturas/documentos" element={hasPermission('Assinaturas') ? <RegulamentoAssinaturasDocumentosPage /> : <Navigate to="/home" replace />} />
            <Route path="/assinaturas/atestos-mensais" element={hasPermission('Assinaturas') ? <RegulamentoAssinaturasDocumentosPage tipoFixo="ATESTO_AVALIACAO" tituloPagina="Atestos Mensais" mostrarFiltroSetor /> : <Navigate to="/home" replace />} />
            <Route path="/assinaturas/processo-pagamento" element={hasPermission('Assinaturas') ? <RegulamentoAssinaturasDocumentosPage tipoFixo="PROCESSO_PAGAMENTO" tituloPagina="Processo de Pagamento — Assinaturas" /> : <Navigate to="/home" replace />} />
            <Route path="/assinaturas/processo-contratacao" element={hasPermission('Assinaturas') ? <RegulamentoAssinaturasDocumentosPage tipoFixo="CONTRATACAO" tituloPagina="Processo de Contratação — Assinaturas" /> : <Navigate to="/home" replace />} />
            <Route path="/assinaturas/aditivo" element={hasPermission('Assinaturas') ? <RegulamentoAssinaturasDocumentosPage tipoFixo="ADITIVO" tituloPagina="Aditivos — Assinaturas" /> : <Navigate to="/home" replace />} />
            <Route path="/assinaturas/minuta" element={hasPermission('Assinaturas') ? <RegulamentoAssinaturasDocumentosPage tipoFixo="MINUTA" tituloPagina="Minutas — Assinaturas" /> : <Navigate to="/home" replace />} />
            <Route path="/assinaturas/diversos" element={hasPermission('Assinaturas') ? <RegulamentoAssinaturasDocumentosPage tipoFixo="DIVERSOS" tituloPagina="Documentos Diversos — Assinaturas" /> : <Navigate to="/home" replace />} />
            <Route path="/assinaturas/documentos/:id" element={hasPermission('Assinaturas') ? <RegulamentoAssinaturasDocumentoDetalhePage /> : <Navigate to="/home" replace />} />
            <Route path="/configuracao" element={hasPermission('Configuracao') ? <ConfiguracaoPage /> : <Navigate to="/home" replace />} />
            <Route path="/lgpd" element={<LgpdPage />} />
            <Route path="/perfil" element={<PerfilPage />} />
            <Route path="/gestao-usuarios" element={hasPermission('GestaoUsuarios') ? <GestaoUsuariosPage /> : <Navigate to="/home" replace />} />
          </Routes>
          </Box>
        </ErrorBoundary>
      </Box>
    </Box>
      )}
      <ChatWidget />
      <LgpdConsentimentoDialog
        open={lgpdConsentOpen && !!user}
        politicasPendentes={lgpdPendentes}
        unidadeSelecionada={unidadeSelecionada}
        onAceito={() => {
          setLgpdConsentOpen(false);
          setLgpdPendentes([]);
        }}
        onClose={() => {
          setLgpdConsentOpen(false);
          logout();
        }}
      />
    </ChatProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <PrestadorAuthProvider>
        <Router>
          <AppContent />
        </Router>
      </PrestadorAuthProvider>
    </AuthProvider>
  );
}

export default App;

